export default __webpack_public_path__ + "static/media/GR00064-w_splash.929560c9.svg";